import { render } from "./AgregarEquipos.vue?vue&type=template&id=0020608e"
import script from "./AgregarEquipos.vue?vue&type=script&lang=js"
export * from "./AgregarEquipos.vue?vue&type=script&lang=js"

import "./AgregarEquipos.vue?vue&type=style&index=0&id=0020608e&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__